<template>
<div class="chapter">
<div class="inner_page">
<h3 class="sigil_not_in_toc">PART TWO</h3>
<p class="firstcenter"><img alt="38223.jpg" src="Images/partding.jpg"/></p>
<h1 id="toc_marker-8" title="Part 2: Reflections on the Basic Assumptions of Economics" xml:lang="fr-FR">Reflections on the<br/>
   Basic Assumptions<br/>
   of Economics</h1>
<h2 class="sigil_not_in_toc"><br/></h2>
<p class="body"></p>
<p class="body"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part2.vue?481f4ce4